import { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminNavbar from "./AdminNavbar";
import AdminBottomNavigation from "./AdminBottomNavigation";
import AdminAuthGuard from "./AdminAuthGuard";

const AdminLayout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <AdminAuthGuard>
      <div className="flex flex-col min-h-screen bg-bbz-cream">
        <AdminNavbar isOpen={isMenuOpen} toggle={toggleMenu} />
        <main className="flex-grow pb-16 lg:pb-0">
          <Outlet />
        </main>
        <AdminBottomNavigation />
      </div>
    </AdminAuthGuard>
  );
};

export default AdminLayout;